import axios from "axios";

const instance = axios.create({ baseURL: "https://api.kpcl.stepnstones.in/" });
 //const instance = axios.create({ baseURL: "http://localhost:8000" });
// const instance = axios.create({ baseURL: "https://192.168.1.105:44329" });


export default instance;
